import KFooter from 'app/components/UI-Elements/Layout/KFooter'
import testIds from 'test_ids.json'

export const checkoutFooterPortalId = 'kfooter-portal'

type Props = {
  id?: string
}
// This footer is mainly used for drawers during checkout.
export const CheckoutFooter: React.FC<Props> = ({ id = checkoutFooterPortalId }) => (
  <KFooter sticky={false}>
    <div id={id} data-testid={testIds.checkout.drawer.footer_button} />
  </KFooter>
)
